import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const NotificationPopup = ({ isOpen, onClose, onApply, onClear }) => {

    const notifications = [
        {
            id: 1,
            sender: 'Sr. Manager',
            avatar: '/assets/avatar01.png',
            action: 'sent you',
            documentName: 'New Project Memo',
            fileName: 'New_project_memo.pdf',
            fileType: '/assets/pdfile.svg',
            time: '5 min ago'
        },
        {
            id: 2,
            sender: 'CEO',
            avatar: '/assets/avatar01.png',
            action: 'return you the Document',
            documentName: 'New Project Memo',
            fileName: 'New_project_memo.pdf',
            fileType: '/assets/pdfile.svg',
            additionalText: 'for comments',
            time: '6 min'
        },
        {
            id: 3,
            sender: 'Marketing Team',
            avatar: '/assets/avatar01.png',
            action: 'Meeting Notes',
            fileName: 'marketing_meeting_notes.pdf',
            fileType: '/assets/pdfile.svg',
            time: '15 min'
        },
        {
            id: 4,
            sender: 'Quarterly Financial Report',
            avatar: '/assets/avatar01.png',
            fileName: 'Q4_financial_report.xlsx',
            fileType: '/assets/pdfile.svg',
            time: '30 min'
        },
        {
            id: 5,
            sender: 'Product Development Updates',
            avatar: '/assets/avatar01.png',
            fileName: 'product_updates.pptx',
            fileType: '/assets/pdfile.svg',
            time: '50 min'
        }
      ];

  return (
    <div
      tabIndex={0}
      className={
        isOpen
          ? "dropdown-content bg-white pb-5 mb-2 w-[368px] h-auto z-50 absolute top-[68px] right-16 shadow-lg"
          : "hidden"
      }
    >
      {/* Header */}
          <div className="bg-white">
              {/* Header */}
              <div className="flex justify-between items-center border-b px-4 py-3">
                  <h2 className="sub_title">Notifications</h2>
                  <Link to='notification'>
                  <button className="para text-sm px-4 py-1 bg-gray-100 rounded hover:bg-gray-200"  onClick={onClose}>
                      View All
                  </button>
                  </Link>
              </div>

              {/* Notifications list */}
              <div className="max-h-auto overflow-y-auto">
                  {notifications.map((notification) => (
                      <div key={notification.id} className="border-b hover:bg-gray-50">
                          <div className="flex items-center px-4 py-3">
                              <div className="flex-shrink-0 mr-3">
                                  <img
                                      src={notification.avatar}
                                      alt={notification.sender}
                                      className="h-8 w-8 rounded-full"
                                  />
                              </div>
                              <div className="flex-grow w-full">
                                  <div className="flex flex-wrap gap-1 items-center text-sm">
                                      <span className="para !font-semibold">{notification.sender}</span>
                                      {notification.action && (
                                          <span className="para">{notification.action}</span>
                                      )}
                                      {notification.documentName && (
                                          <span className="para !font-semibold">{notification.documentName}</span>
                                      )}
                                      {notification.additionalText && (
                                          <span className="">{notification.additionalText}</span>
                                      )}
                                  </div>
                                  <div className="mt-1 border border-gray-100 rounded px-3 py-1 flex items-center w-fit">
                                      <img
                                          src={notification.fileType}
                                          alt={notification.fileType}
                                          className="h-5 w-5 mr-2"
                                      />
                                      <span className="text-xs text-gray-600">{notification.fileName}</span>
                                  </div>
                                  <div className="mt-1 text-xs text-gray-500">{notification.time}</div>
                              </div>
                              <div className="flex-shrink-0">
                                  <ChevronRight size={20} className="text-gray-400" />
                              </div>
                          </div>
                      </div>
                  ))}
              </div>
          </div>
    </div>
  );
};

export default NotificationPopup;
